module.exports = __webpack_public_path__ + "img/art-r-tjImg_03.14d5e9b5.png";